import * as React from 'react';
import { ProtectedPage } from '../genericComponents/Page/ProtectedPage/ProtectedPage';
import { UserRole } from '../../types/UserRole';
import './LoginPage.css';
import { CenterContainer } from './internalComponents/CenterContainer';
import { ChangePasswordForm } from './internalComponents/ChangePasswordForm';

/**
 * ce composant permet la reinitialisation du mot de passe
 */
export class ResetPasswordPage extends React.Component {
    props: {
        match: { path: string, url: string, isExact: boolean, params: { token: string } };
    };
    state: {};

    constructor(props: {}) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <ProtectedPage
                allowedUsers={[
                    UserRole.USER,
                    UserRole.SUPER_ADMIN,
                    UserRole.SEMI_PRO,
                    UserRole.NOT_LOGED_IN,
                    UserRole.MEMBER,
                    UserRole.ADMIN,
                ]}
            >
                <div className="LoginPageChorinitia">
                    <CenterContainer>
                        <ChangePasswordForm token={this.props.match.params.token}/>
                    </CenterContainer>
                </div>
            </ProtectedPage>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage/ResetPasswordPage.tsx